import React from 'react';
import { Link } from 'react-router-dom';
import './Solutions.css';

const Solutions = () => {
  return (
    <div className="solutions-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Solutions Hero Background" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <h1>Our Solutions</h1>
          <p>Tailored technology solutions designed to meet your specific business needs and industry requirements</p>
        </div>
      </section>

      {/* Solutions Overview */}
      <section className="solutions-overview">
        <div className="container">
          <div className="solutions-intro">
            <h2>Industry-Specific Solutions</h2>
            <p>We understand that different industries have unique technology requirements. Our solutions are designed to address the specific challenges and opportunities in your sector, helping you achieve operational excellence and competitive advantage.</p>
          </div>
        </div>
      </section>

      {/* Industry Solutions */}
      <section className="industry-solutions">
        <div className="container">
          <h2 className="section-title">Industry Solutions</h2>
          <p className="section-subtitle">Comprehensive technology solutions for various industries</p>
          
          <div className="solutions-grid">
            <div className="solution-card">
              <div className="solution-image">
                <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Enterprise Solutions" />
              </div>
              <div className="solution-icon">
                <i className="fas fa-building"></i>
              </div>
              <h3>Enterprise Solutions</h3>
              <p>Comprehensive IT infrastructure and digital transformation solutions for large enterprises.</p>
              <ul>
                <li>Scalable infrastructure design</li>
                <li>Enterprise security implementation</li>
                <li>Cloud migration strategies</li>
                <li>Digital transformation consulting</li>
              </ul>
            </div>

            <div className="solution-card">
              <div className="solution-image">
                <img src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Manufacturing" />
              </div>
              <div className="solution-icon">
                <i className="fas fa-industry"></i>
              </div>
              <h3>Manufacturing</h3>
              <p>Technology solutions to optimize manufacturing processes and improve operational efficiency.</p>
              <ul>
                <li>Industrial IoT implementation</li>
                <li>Production automation</li>
                <li>Quality control systems</li>
                <li>Supply chain optimization</li>
              </ul>
            </div>

            <div className="solution-card">
              <div className="solution-image">
                <img src="https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Healthcare" />
              </div>
              <div className="solution-icon">
                <i className="fas fa-hospital"></i>
              </div>
              <h3>Healthcare</h3>
              <p>Secure and compliant technology solutions for healthcare organizations and medical facilities.</p>
              <ul>
                <li>HIPAA-compliant systems</li>
                <li>Medical device integration</li>
                <li>Patient data security</li>
                <li>Telemedicine infrastructure</li>
              </ul>
            </div>

            <div className="solution-card">
              <div className="solution-image">
                <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Education" />
              </div>
              <div className="solution-icon">
                <i className="fas fa-graduation-cap"></i>
              </div>
              <h3>Education</h3>
              <p>Technology solutions to enhance learning environments and educational institutions.</p>
              <ul>
                <li>Digital learning platforms</li>
                <li>Smart classroom technology</li>
                <li>Student management systems</li>
                <li>Remote learning infrastructure</li>
              </ul>
            </div>

            <div className="solution-card">
              <div className="solution-image">
                <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Retail & E-commerce" />
              </div>
              <div className="solution-icon">
                <i className="fas fa-shopping-cart"></i>
              </div>
              <h3>Retail & E-commerce</h3>
              <p>Technology solutions to enhance customer experience and streamline retail operations.</p>
              <ul>
                <li>Point-of-sale systems</li>
                <li>Inventory management</li>
                <li>Customer analytics</li>
                <li>E-commerce platforms</li>
              </ul>
            </div>

            <div className="solution-card">
              <div className="solution-image">
                <img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Financial Services" />
              </div>
              <div className="solution-icon">
                <i className="fas fa-university"></i>
              </div>
              <h3>Financial Services</h3>
              <p>Secure and compliant technology solutions for financial institutions and fintech companies.</p>
              <ul>
                <li>Regulatory compliance</li>
                <li>Fraud detection systems</li>
                <li>Digital banking platforms</li>
                <li>Risk management tools</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Solutions */}
      <section className="technology-solutions">
        <div className="container">
          <h2 className="section-title">Technology Solutions</h2>
          <p className="section-subtitle">Advanced technology solutions to drive your business forward</p>
          
          <div className="tech-solutions-grid">
            <div className="tech-solution">
              <div className="tech-icon">
                <i className="fas fa-cloud"></i>
              </div>
              <h3>Cloud Migration</h3>
              <p>Seamless migration to cloud platforms with minimal disruption to your business operations.</p>
              <Link to="/services#cloud" className="solution-link">Learn More</Link>
            </div>

            <div className="tech-solution">
              <div className="tech-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Cybersecurity</h3>
              <p>Comprehensive security solutions to protect your data and infrastructure from evolving threats.</p>
              <Link to="/services#security" className="solution-link">Learn More</Link>
            </div>

            <div className="tech-solution">
              <div className="tech-icon">
                <i className="fas fa-network-wired"></i>
              </div>
              <h3>Network Infrastructure</h3>
              <p>Robust and scalable network solutions to support your growing business needs.</p>
              <Link to="/services#networking" className="solution-link">Learn More</Link>
            </div>

            <div className="tech-solution">
              <div className="tech-icon">
                <i className="fas fa-server"></i>
              </div>
              <h3>Data Center Solutions</h3>
              <p>Enterprise-grade data center infrastructure and management solutions.</p>
              <Link to="/services#infrastructure" className="solution-link">Learn More</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="success-stories">
        <div className="container">
          <h2 className="section-title">Success Stories</h2>
          <p className="section-subtitle">How we've helped organizations transform their technology infrastructure</p>
          
          <div className="stories-grid">
            <div className="story-card">
              <div className="story-header">
                <h3>Manufacturing Excellence</h3>
                <span className="industry-tag">Manufacturing</span>
              </div>
              <p>"TecMates helped us implement a comprehensive IoT solution that improved our production efficiency by 40% and reduced operational costs significantly."</p>
              <div className="story-results">
                <div className="result-item">
                  <strong>40%</strong>
                  <span>Efficiency Improvement</span>
                </div>
                <div className="result-item">
                  <strong>30%</strong>
                  <span>Cost Reduction</span>
                </div>
              </div>
            </div>

            <div className="story-card">
              <div className="story-header">
                <h3>Healthcare Transformation</h3>
                <span className="industry-tag">Healthcare</span>
              </div>
              <p>"Our partnership with TecMates enabled us to implement secure, HIPAA-compliant systems that enhanced patient care while maintaining data security."</p>
              <div className="story-results">
                <div className="result-item">
                  <strong>100%</strong>
                  <span>HIPAA Compliance</span>
                </div>
                <div className="result-item">
                  <strong>50%</strong>
                  <span>Faster Processing</span>
                </div>
              </div>
            </div>

            <div className="story-card">
              <div className="story-header">
                <h3>Educational Innovation</h3>
                <span className="industry-tag">Education</span>
              </div>
              <p>"TecMates transformed our educational institution with modern technology solutions that enhanced student engagement and learning outcomes."</p>
              <div className="story-results">
                <div className="result-item">
                  <strong>60%</strong>
                  <span>Student Engagement</span>
                </div>
                <div className="result-item">
                  <strong>25%</strong>
                  <span>Performance Improvement</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let's discuss how our tailored solutions can address your specific challenges and drive your digital transformation journey.</p>
          <Link to="/contact" className="btn btn-primary">Get Started Today</Link>
        </div>
      </section>
    </div>
  );
};

export default Solutions; 